import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createStaticVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/giphy.vue
var o = {
	name: "DtIconGiphy",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--giphy"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Giphy",
		viewBox: "0 0 16 16",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2.667h8v10.666H4V2.667Z\" fill=\"currentColor\"></path><path d=\"M2 2h2v12H2V2Z\" fill=\"#04FF8E\"></path><path d=\"M12 5.333h2V14h-2V5.333Z\" fill=\"#8E2EFF\"></path><path d=\"M2 13.333h12v2H2v-2Z\" fill=\"#00C5FF\"></path><path d=\"M2 .667h6.667v2H2v-2Z\" fill=\"#FFF152\"></path><path d=\"M12.223 4.222V2.445h-1.779V.667H8.667V6H14V4.222\" fill=\"#FF5B5B\"></path><path d=\"M12 7.333V6h2\" fill=\"#551C99\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.667.667v2H7.333\" fill=\"#999131\"></path>", 8)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=giphy.js.map